// One post of a conversation in tree view, and its replies below it. All
// it shares with the other levels comes from the `thread` context that
// Conversation provides.
const ThreadTree = {
  name: 'ThreadTree',
  inject: ['thread'],
  props: {
    depth: Number,
    statusId: String,
  },
  computed: {
    currentReplies() {
      return this.thread.getReplies(this.statusId).map(({ id }) => id)
    },
    threadShowing() {
      return this.thread.threadDisplayStatus[this.statusId] === 'showing'
    },
    replyCount() {
      return this.thread.totalReplyCount[this.statusId]
    },
  },
}

export default ThreadTree
